import React, { useState } from "react";
import { useLoaderData, useRevalidator } from "react-router-dom";
import { CloseOutlined } from "@mui/icons-material";
import {
  Alert,
  AlertTitle,
  Button,
  CircularProgress,
  Dialog,
} from "@mui/material";

import ResponseModal from "../../../../global/ResponseModal";
import ModalButton from "../../../../global/ModalButton";
import ApiRequestErrorHandler from "../../../../global/ApiRequestErrorHandler";
import getDocumentTypeName from "../../../../global/getDocumentTypeName";
import { useDocumentListStore } from "../hooks/useDocumentListStore";
export default function DeleteDocumentModal({
  openDeleteModal,
  setOpenDeleteModal,
  getExtension,
  documentTypeObj,
  doc,
}) {
  const { revalidate } = useRevalidator();
  const { deleteDocument } = useLoaderData();

  const defaultResponseModal = {
    open: false,
    isError: false,
    title: "",
    description: "",
    errorMessage: [],
  };

  const { fileName, documentType, file, pk } = doc || {};
  const [responseModal, setResponseModal] = useState(defaultResponseModal);
  const {totalFolderCount, totalDocumentCount, setFolderId, parentFolderId} = useDocumentListStore();

  const previewStyles = {
    textAlign: "center",
    fontSize: "1.2rem",
    margin: "10px",
  };

  const objectStyles = {
    width: "100%",
    height: "100%",
    display: "block",
    minHeight: "80vh",
  };

  const handleCloseResponseModal = () => {
    setResponseModal(defaultResponseModal);
    if (!responseModal.isError) {
      setOpenDeleteModal(false);
      if(totalFolderCount === 0 && totalDocumentCount === 1) {
        setFolderId(parentFolderId);
      }
      revalidate();
    }
  };

  const showResponseModal = ({ isError, title, description = "", errorMessage = [] }) => {
    setResponseModal({
      open: true,
      isError,
      title,
      description,
      errorMessage,
    });
  };

  const handleDeleteDocument = async () => {
    try {
      await deleteDocument(pk);
      showResponseModal({
        isError: false,
        title: "Document/Image Delete Success",
        description: "The Document/Image was successfully removed from this case",
      });
    } catch (error) {
      const errArr = error?.response ? ApiRequestErrorHandler(error?.response?.data) : [];
      showResponseModal({
        isError: true,
        title: "Deletion failed",
        errorMessage: errArr,
      });
    }
  };

  return (
    <>
      <Dialog open={openDeleteModal}>
        <Alert
          variant="outlined"
          severity="error"
          role="error"
          style={{ paddingRight: "40px" }}
        >
          <AlertTitle
            style={{
              display: "flex",
              justifyContent: "space-between",
              margin: "0 0 1rem",
            }}
          >
            Delete Document
            <Button onClick={() => setOpenDeleteModal(false)} style={{ padding: "0" }}>
              <CloseOutlined />
            </Button>
          </AlertTitle>

          <h1 style={{ textAlign: "center", fontSize: "1.5rem", margin: "1rem 0" }}>
            Confirm document deletion
          </h1>

          <div style={{ margin: "0 auto" }}>
            {!file ? (
              <CircularProgress color="secondary" />
            ) : (
              <div>
                <p><strong>File Name: </strong>{fileName}</p>
                <p>
                  <strong>File Type: </strong>
                  {getDocumentTypeName(documentTypeObj, documentType) || "No type added"}
                </p>
                {getExtension(fileName) === "" ? (
                  <p style={previewStyles}>No File Preview Available</p>
                ) : (
                  <object data={file} aria-label={fileName} style={objectStyles}></object>
                )}
              </div>
            )}
          </div>

          <ModalButton
            className="block"
            action={handleDeleteDocument}
            baseColor="#d32f2f"
            icon="delete"
            content="Confirm Document Delete"
          />
        </Alert>
      </Dialog>

      <ResponseModal
        title={responseModal.title}
        description={responseModal.description}
        isError={responseModal.isError}
        openBool={responseModal.open}
        setOpenBool={(val) => setResponseModal((prev) => ({ ...prev, open: val }))}
        handleCloseFunc={handleCloseResponseModal}
        errorMessage={responseModal.errorMessage}
      />
    </>
  );
}